<template>
  <div class="grey lighten-4">
    <!-- <v-breadcrumbs :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon>forward</v-icon>
      </template>
    </v-breadcrumbs> -->
    <!-- <locationnodes :locationnodes="locationNodes" @locationNodeSaved="fetchLocationNodes()"></locationnodes> -->
      <contactdetail @contactChange="getLinkedLocations()" :contact="contact" :linkedLocations="locations" ></contactdetail>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import ContactDetail from '@/components/ContactDetail'
export default {
  components: {
      contactdetail: ContactDetail
      },
      watch:{
      '$route.params.contactId': {
          immediate: true,
          handler(value){
                 this.initialize()
          }
      }
  },
  data() {
    return {
      showDetails: true,
      serviceAccounts: [],
      locations:[],
      contact:'',
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      pagination: {},
      locationNetworkInfo: [],
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/"
        },
        {
          text: "Location Nodes",
          disabled: false,
          href: "/locations"
        },
        {
          text: "Location Networks",
          disabled: false,
          href: "/locations"
        }
      ],

      
      
    };
  },

  computed: {
    formattedDate() {
      return this.due ? format(this.due, "Do MMM YYYY") : "";
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/contacts/:contactId'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },

  methods: {
    getContactInfo(){
        Api()
        .get('/contacts/'+this.$route.params.contactId)
        .then(response=>{
            this.contact=response.data[0]
        })
    },
    getLinkedLocations() {
      Api()
        .get("/LocationContact/byContact/" + this.$route.params.contactId)
        .then(response => {
          this.locations = response.data;
        });
    },
    getLocationInfo() {
      Api()
        .get("/locationnetworks/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.locationNetworkInfo = response.data[0];
        });
    },
    initialize() {
        this.getContactInfo();
      this.getLinkedLocations();
    },
    goToLocations(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        path: "/locationnetworks/" + this.editedItem.id + "/locations"
      });
    },
    editItem(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.locationNetworks.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.locationNetworks.splice(index, 1);
      Api().delete("/locationnetworks/" + this.editedItem.id);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if(this.locationNetworkInfo.tvOverFibre===false){
        this.locationNetworkInfo.gtuIncluded=false;
      }
      if(this.locationNetworkInfo.lineRentalIncluded===false){
        this.locationNetworkInfo.residentialLineRentalValue=0;
      }
      Api().put("/locationnetworks/" + this.locationNetworkInfo.id, {
        name: this.locationNetworkInfo.name,
        locationNodeId: this.locationNetworkInfo.locationNodeId,
        lineRentalIncluded: this.locationNetworkInfo.lineRentalIncluded,
        tvOverFibre: this.locationNetworkInfo.tvOverFibre,
        gtuIncluded: this.locationNetworkInfo.gtuIncluded,
        activationFee: this.locationNetworkInfo.activationFee,
        routerInstallationFee: this.locationNetworkInfo.routerInstallationFee,
        residentialLineRentalValue: this.locationNetworkInfo.residentialLineRentalValue,
        isDeleted: false,
        isActive: this.locationNetworkInfo.isActive
      });

      this.locationNetworks.push(this.editedItem);
    }
  }
};
</script>
<style>
.v-chip.Active {
  background: #1ebb2c;
}
.v-chip.Inactive {
  background: #f0121e;
}
.v-chip.activationFee {
  background: #0fc5f3;
}
.v-chip.tvOverFibre {
  background: #b8c417;
}
.v-chip.gtuIncluded {
  background: #dfc013;
}
</style>

